module.exports = __webpack_public_path__ + "img/14-pilvilinna.ebdf846a.jpg";